import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getModelContext, registerTools } from "../webmcp/modelContext";
import { buildTools } from "../webmcp/tools";

/**
 * Offer this page's tools to an agent working in the browser
 * (projects/webmcp W1): registered once the shell knows who's signed in,
 * all unregistered (one AbortController) when the shell unmounts — signing
 * out, or leaving it. Without WebMCP in this browser it does nothing.
 *
 * The router and the account are read through refs, so moving around the
 * app or changing your picture doesn't re-register; a different person
 * signing in does.
 */
export default function useWebMcpTools(me) {
  const location = useLocation();
  const navigate = useNavigate();
  const where = useRef(location);
  const go = useRef(navigate);
  const who = useRef(me);
  where.current = location;
  go.current = navigate;
  who.current = me;
  const meId = me?.id ?? null;

  useEffect(() => {
    const context = getModelContext();
    if (!context || meId === null) return undefined;
    const controller = new AbortController();
    registerTools(
      context,
      buildTools({
        getLocation: () => where.current,
        navigate: (to) => go.current(to),
        getMe: () => who.current,
      }),
      controller.signal,
    );
    return () => controller.abort();
  }, [meId]);
}
